import { getCurrentOrgKey } from './session'

export const API_BASE = '/api/v1'
export const ADMIN_API_BASE = `${API_BASE}/admin`

export * from './session'

export function getBaseUrl(organization?: { key: string }): string {
  const orgKey = organization ? organization.key : getCurrentOrgKey()
  const suffix = orgKey ? `/${orgKey}` : ''
  return `${API_BASE}${suffix}`
}

export function getRootUrl(): string {
  return API_BASE
}
